import { useTranslation } from 'react-i18next';
import { ChaptersStatus } from 'api';
import DFCAgreePurchaseModal from './DFCAgreePurchaseModal';
import BasePurchaseDialog, { PurchaseSummaryLine } from '../BasePurchaseDialog';

export type DFCPurchaseDialogProps = {
  open: boolean;
  onClose: () => void;
  handleConfirmPurchase: () => void;
  chapterSummaries: PurchaseSummaryLine[];
  purchaseChapters: ChaptersStatus[];
  contributorsCount: number;
  unitBalance: number;
  firstModalOpen: boolean;
  OnConfirm: () => void;
  OnDecline: () => void;
  newContributors: number;
  showNewContributors: boolean;
  isPurchaseLoading: boolean;
};

const DFCPurchaseDialog = ({
  open,
  onClose,
  handleConfirmPurchase,
  chapterSummaries,
  purchaseChapters,
  contributorsCount,
  unitBalance,
  firstModalOpen,
  OnConfirm,
  OnDecline,
  newContributors,
  showNewContributors,
  isPurchaseLoading,
}: DFCPurchaseDialogProps) => {
  const { t } = useTranslation();

  return (
    <BasePurchaseDialog
      open={open}
      onClose={onClose}
      onSubmit={handleConfirmPurchase}
      disabled={isPurchaseLoading}
      chapterSummaries={chapterSummaries}
      purchaseChapters={purchaseChapters}
      unitBalance={unitBalance}
      contributorsCount={contributorsCount}
      newContributors={newContributors}
      showNewContributors={showNewContributors}
      primaryButtonText={t('ui.event-management.learner.purchase.button')}
      secondaryButtonText={t('ui.event-management.cancel')}
      title={t('ui.event-management.learner.purchase.button')}
      extraContent={
        firstModalOpen ? (
          <DFCAgreePurchaseModal
            open={firstModalOpen}
            onConfirm={OnConfirm}
            onDecline={OnDecline}
          />
        ) : null
      }
      variant="dfc"
    />
  );
};

export default DFCPurchaseDialog;
